// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"6462336e","540":"635755bc"}[chunkId] + ".chunk.js";
};